/*
  SUK homepage category tiles - show a different product image on every page load.

  The tile row is the stock `collection-list` section; its blocks, order and labels
  are untouched. Only the <img> inside each card is swapped, so positions never move.

  The candidate images are rendered server-side by the "Tile image pool" Custom Liquid
  section in templates/index.json, which emits <script id="suk-tile-pool">. Doing it that
  way keeps the payload at a few KB - /collections/<handle>/products.json is 3.2 MB for
  silicone-hoses alone because it inlines every variant.

  Nothing in the stock theme is modified, so an Ignite upgrade cannot revert this.
*/
(function () {
  var data = document.getElementById('suk-tile-pool');
  if (!data) return;

  var pool;
  try {
    pool = JSON.parse(data.textContent);
  } catch (e) {
    return;
  }

  // Shopify prefixes template section ids at render time
  // (shopify-section-template--30180461511033__collection_list_8epked), so match the
  // suffix rather than the bare id, which only holds inside the theme editor.
  var id = data.getAttribute('data-target-section');
  var root =
    document.querySelector('[id^="shopify-section"][id$="__' + id + '"]') ||
    document.getElementById('shopify-section-' + id);
  if (!root) return;

  // Liquid emits every URL with an explicit &width=; retarget it rather than appending
  // a second width param, which the CDN ignores.
  function sized(url, w) {
    return /[?&]width=\d+/.test(url)
      ? url.replace(/([?&])width=\d+/, '$1width=' + w)
      : url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  // Identity of an image, ignoring the width/version query: two tiles must not both
  // land on the same photo when a product sits in two collections (the clear ducting
  // is in both pvc-hoses and air-ducting, the heat shield in metal-pipes and air-filters).
  // Liquid emits protocol-relative URLs (//siliconehoseuk.co.uk/cdn/...) while a rendered
  // img.src reads back absolute, so drop the scheme too or the two never compare equal.
  function key(url) {
    return url.split('?')[0].replace(/^https?:/, '');
  }

  var cards = Array.prototype.slice.call(root.querySelectorAll('.card-wrapper'));

  // Shuffle the order tiles are picked in. Picking left-to-right would always spend the
  // shared images on the leftmost tile and leave the rightmost one with no free choice.
  var order = cards.map(function (_, i) { return i; });
  for (var i = order.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var t = order[i]; order[i] = order[j]; order[j] = t;
  }

  var taken = {};

  // A tile with nothing to rotate between keeps the image it was served, so reserve that
  // up front - otherwise a rotating tile could pick the very image sitting next to it.
  cards.forEach(function (card) {
    var link = card.querySelector('a[href*="/collections/"]');
    var img = card.querySelector('.card__media img');
    if (!link || !img) return;
    var m = link.getAttribute('href').match(/\/collections\/([^/?#]+)/);
    var urls = m && pool[m[1]];
    if (urls && urls.length >= 2) return;
    var current = img.getAttribute('src');
    if (current) taken[key(current)] = true;
  });

  order.forEach(function (idx) {
    var card = cards[idx];
    var link = card.querySelector('a[href*="/collections/"]');
    var img = card.querySelector('.card__media img');
    if (!link || !img) return;

    var match = link.getAttribute('href').match(/\/collections\/([^/?#]+)/);
    if (!match) return;

    var urls = pool[match[1]];
    if (!urls || urls.length < 2) return; // nothing to rotate between - leave the tile alone

    // Prefer images no other tile has taken; fall back to the full pool rather than
    // leaving a tile empty if every candidate is already spoken for.
    var free = urls.filter(function (u) { return !taken[key(u)]; });
    var from = free.length ? free : urls;

    var pick = from[Math.floor(Math.random() * from.length)];
    taken[key(pick)] = true;

    var src = sized(pick, 535);

    // Preload first: a 404 or a slow CDN miss must not blank out a tile that is
    // already showing a perfectly good image.
    var probe = new Image();
    probe.onload = function () {
      img.setAttribute(
        'srcset',
        sized(pick, 330) + ' 330w, ' + src + ' 535w, ' + sized(pick, 750) + ' 750w'
      );
      img.setAttribute('src', src);
      img.setAttribute('loading', 'eager');
    };
    probe.src = src;
  });
})();
